import React, { useEffect } from 'react'
import { AppDispatch } from '../../../core/data/redux/store';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { fetchPolicyById } from '../../../core/data/redux/policy/policyAction';
import { Typography, Space } from 'antd';
import { formatDate } from '../../../core/utils/configFormatters';
import { useAppConfig } from '../../../customhooks/useAppConfig';
const { Title, Text } = Typography; 

const PolicyDetails = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { policyId } = useParams<{ policyId: any }>();
    const { selectedPolicy, loading } = useSelector((state: any) => state.policy);
    useEffect(() => {
        if (policyId) {
            dispatch(fetchPolicyById({ policyId }))
        }
    }, [dispatch, policyId])

    const config = useAppConfig();
    if (!config) return null;

    return (
        <div className="page-wrapper">
            <div className="content">
                <h2>Policy Details</h2>

                {loading && <p>Loading policy...</p>}
                {!loading && selectedPolicy ? (
                    <>
                        <div className="policy-header my-4">
                            <div className="card p-3 shadow-sm">
                                <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                                    <Space size="large" wrap>
                                        <div>
                                            <Text strong>Name:</Text> <Text>{selectedPolicy.Name}</Text>
                                        </div>
                                        <div>
                                            <Text strong>Effective Date:</Text> <Text>{formatDate(selectedPolicy.EffectiveDate, config)}</Text>
                                        </div>
                                        {/* <div>
                                            <Text strong>Department:</Text> <Text>{selectedPolicy.DepartmentName}</Text>
                                        </div> */}
                                        <div>
                                            <Text strong>Policy Category:</Text> <Text>{selectedPolicy.SelectedType}</Text>
                                        </div>
                                    </Space>
                                </Space>
                            </div>
                        </div>

                        {selectedPolicy.PolicyDocURL ? (
                            <iframe
                                src={`${selectedPolicy.PolicyDocURL}`}
                                title="Policy Document"
                                width="100%"
                                height="600px"
                                style={{ border: '1px solid #ccc' }}
                            ></iframe>
                        ) : (
                            <p>No policy document available.</p>
                        )}
                    </>
                ) : (
                    !loading && <p>No policy found.</p>
                )}
            </div>
        </div>
    )
}

export default PolicyDetails;